import React,{useEffect, useState} from 'react';
import "./Section1.css";
import backGround from "../../Pyragon/03.png";




import Hero from '../../site/content/hero.json'
import Values from '../../site/content/values.json'
// import How from '../../site/content/how.json'
// import Purchase from '../../site/content/purchase.json'
// import Tokenomics from '../../site/content/tokenomics.json'
// {Hero["card"]}
import Zoom from 'react-reveal/Zoom';
import Slide from 'react-reveal/Slide';
import Fade from 'react-reveal/Fade';

const Section1 = () => {
    const [changepos , setChangePos] = useState(-200);
    
    useEffect(() => {
        window.addEventListener('scroll' , ()=>{
            setChangePos(window.scrollY + 10);
        })
    }, [])
    
    return (
        <>
        <div className="launch-soon">
            <h1>Launch coming soon <span><img src="https://img.icons8.com/emoji/452/rocket-emji.png" alt="ROCKET" /></span></h1>
        </div>
        <div id="main-container-section1" >
                <div id="img-div" style={{top : changepos<50 ? 200 : -changepos}}></div>
                {/* <div id="img-div-2"></div> */}
                <img class="demo-bg-section1" src={backGround} alt="" />
            <Fade left> 
                <h1>{Hero["heading"]}</h1>
                <p>{Hero["sub-heading"]}</p>
                <div id="btn-group">
                    <button id="btn-group-1">{Hero["button-one"]}</button>
                
                    <button id="btn-group-2">{Hero["button-two"]}</button>
                </div>
            </Fade>
            <Zoom left cascade>
                <div id="footer">
                    <div class="footer-section-container">
                        <button>{Values["card-one-title"]}</button>
                        <h5>{Values["card-one-value"]}</h5>
                    </div>

                    <div class="footer-section-container">
                        <button>{Values["card-two-title"]}</button>
                        <h5>{Values["card-two-value"]}</h5>
                    </div>

                    <div class="footer-section-container">
                        <button>{Values["card-three-title"]}</button>
                        <h5>{Values["card-three-value"]}</h5>
                    </div>

                    <div class="footer-section-container">
                        <button>{Values["card-four-title"]}</button>
                        <h5>{Values["card-four-value"]}</h5>
                    </div>
                </div>
            </Zoom>
        </div>
        </>
    )
}

export default Section1
